import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link, useParams } from "react-router-dom";
import { Row, Col, Card, Modal, Form, Button } from 'react-bootstrap';
import Select from 'react-select';
import PageLayout from "../../layouts/PageLayout";
import axios from "axios";
import './UserProfilePage.css';
import { API_URL, APP_PREFIX_PATH } from "../../constant/constant";
import { formatPhoneNumber } from "../../utils/formatPhone";
import moment from "moment";

export default function UserProfilePage() {
    const [content, setContent] = useState(0);
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [users, setUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [AllTitleerror, setAllTitleerror] = useState('');
    const [Msgerror, setMsgerror] = useState('');
    const [selecterror, setselecterror] = useState('');
    const [selecttitleerror, setselecttitleerror] = useState('');
    const [selectMsgerror, setselectMsgerror] = useState('');
    const handleButtonClick = (contentType) => {
        setContent(contentTypes[contentType]);
    };

    const { t } = useContext(TranslatorContext)
    const { user_id } = useParams();
    const [Data, setData] = useState('');
    const [enlargedImage, setEnlargedImage] = useState(null);
    const [showImagePopup, setShowImagePopup] = useState(false);

    const [appointment, setappointment] = useState([]);
    const [consultation, setconsultation] = useState([]);

    const contentTypes = {
        all: 0,
        specific: 1
    };


    const getData = () => {
        axios.post(API_URL + '/view_user_by_id', { user_id }).then((res) => {
            setData(res.data.user_arr[0]);

        }).catch((error) => {
            console.log(error);

        })

    }

    const AppointmentData = () => {
        axios.post(API_URL + '/get_appointment_details', { user_id }).then((res) => {
            setappointment(res.data.fetchAppointment_arr);
            console.log('fetchappointment', res.data.fetchAppointment_arr);

        }).catch((error) => {
            console.log(error);

        })
    }

    const ConsultationData = () => {
        axios.post(API_URL + '/get_consultation_details', { user_id }).then((res) => {
            setconsultation(res.data.fetchConsultation_arr);

        }).catch((error) => {
            console.log(error);

        })
    }

    useEffect(() => {
        getData();
        AppointmentData();
        ConsultationData();
    }, [])
    const handleImageClick = (imageUrl) => {
        setEnlargedImage(imageUrl);
        setShowImagePopup(true);
    };
    const handleCloseImage = () => {
        setEnlargedImage(null);
        setShowImagePopup(false);
    };

    return (
        <PageLayout>
            <Col xl={12}>
                <div className="mc-card">
                    <div className='mc-breadcrumb'>
                        <h3 className="mc-breadcrumb-title " style={{ marginLeft: '15px' }}>{t('user_profile')}</h3>
                        <ul className="mc-breadcrumb-list">
                            <li className="mc-breadcrumb-item"><Link to={`${APP_PREFIX_PATH + '/dashboard'}`} className="mc-breadcrumb-link">{t('home')}</Link></li>
                            <li className="mc-breadcrumb-item"><Link to={`${APP_PREFIX_PATH + '/manage-users'}`} className="mc-breadcrumb-link">{t('users')}</Link></li>
                            <li className="mc-breadcrumb-item">{t('user_profile')}</li>
                        </ul>
                    </div>
                </div>
            </Col>
            <div className="mc-card p-lg-4">
                <Row>
                    <Col xl={5}>
                        {/* <h6 className="mc-divide-title mb-4">{t('user_profile')}</h6> */}
                        <div className="mc-user-group">
                            <div className="">
                                <div className="">

                                    <img
                                        src={Data.image ? `${Data.image}` : `image-1720095670109.png`}
                                        alt="Profile"
                                        style={{ width: '15rem', height: '15rem', borderRadius: '5%', cursor: 'pointer' }}
                                        onClick={() => handleImageClick(Data.image ? `${Data.image}` : `image-1720095670109.png`)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                handleImageClick(Data.image ? `${Data.image}` : `image-1720095670109.png`);
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    />

                                    {/* Enlarged image overlay */}
                                    {showImagePopup && (
                                        <div
                                            className="enlarged-image-overlay"
                                            onClick={handleCloseImage}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Escape') {
                                                    handleCloseImage();
                                                }
                                            }}
                                            role="button"
                                            tabIndex={0}
                                        >
                                            <span
                                                className="close-button"
                                                onClick={handleCloseImage}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleCloseImage();
                                                    }
                                                }}
                                                role="button"
                                                tabIndex={0}
                                            >
                                                &times;
                                            </span>
                                            <img src={enlargedImage} alt="Enlarged Profile" className="enlarged-image" style={{ width: '30rem', height: '30rem' }} />
                                        </div>
                                    )}
                                </div>

                            </div>
                        </div>
                    </Col>
                    <Col xl={7}>
                        {/* <h6 className="mc-divide-title mb-4">{t('user_details')}</h6> */}
                        <div className="mc-product-view-info-group">

                            <div className="col-lg-12 content">

                                <div className="row">
                                    <div className="col-lg-4">
                                        <h6 className="mt-2">
                                            {t('name')} : &nbsp;
                                        </h6>

                                    </div>
                                    <div className="col-lg-8">
                                        <span style={{ fontWeight: '400' }}>{Data.name}</span>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <h6 className="mt-2">
                                            {t('email')} : &nbsp;
                                        </h6>


                                    </div>
                                    <div className="col-lg-8">
                                        <span style={{ fontWeight: '400' }}>{Data.email}</span>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <h6 className="mt-2">
                                            {t('phone')} : &nbsp;
                                        </h6>


                                    </div>
                                    <div className="col-lg-8">
                                        <span style={{ fontWeight: '400' }}>{formatPhoneNumber(Data.mobile)}</span>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <h6 className="mt-2">
                                            {t('dob')} : &nbsp;
                                        </h6>

                                    </div>
                                    <div className="col-lg-8">
                                        <span style={{ fontWeight: '400' }}>{Data.dob ? moment(Data.dob).format('DD-MM-YYYY') : 'NA'}</span>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <h6 className="mt-2">
                                            {t('createdatetime')} : &nbsp;
                                        </h6>

                                    </div>
                                    <div className="col-lg-8">
                                        <span style={{ fontWeight: '400' }}>{Data.createtime}</span>
                                    </div>

                                </div>





                            </div>
                        </div>


                    </Col>


                </Row>
                <Card.Body className="mt-5">
                    <Form>
                        <nav className="navbar navbar-expand-lg navbar-light navBar">
                            <div
                                className="container mobile"
                                id="container-div"
                                style={{ marginTop: '-2rem', width: '22rem', borderRadius: '5px', marginLeft: '0rem' }}
                            >
                                <button
                                    className={`btn btn-outline-success me-2 mb-2 btn-content ${content === contentTypes.all ? 'btn-active' : ''}`}
                                    style={{ width: '15rem' }}
                                    type="button"
                                    onClick={() => handleButtonClick('all')}
                                >
                                    {t('appointment')}
                                </button>
                                <button
                                    className={`btn btn-outline-success me-2  mb-2 btn-content ${content === contentTypes.specific ? 'btn-active' : ''}`}
                                    style={{ width: '15rem' }}
                                    type="button"
                                    onClick={() => handleButtonClick('specific')}
                                >
                                    {t('consultation')}
                                </button>
                            </div>
                        </nav>

                        {content === 0 && (
                            <div style={{ margin: '1rem' }}>
                                <div className="mc-table-responsive">
                                    <table className="mc-table">
                                        <thead className="mc-table-head primary">
                                            <tr>
                                                <th>
                                                    <div className="mc-table-check">
                                                        <p>{t("sno")}</p>
                                                    </div>
                                                </th>


                                                <th>{t("clinic_name")}</th>
                                                <th>{t("doctor_name")}</th>
                                                <th>{t("service_name")}</th>
                                                <th>{t("status")}</th>
                                                <th>{t("appointment_date_time")}</th>
                                            </tr>
                                        </thead>
                                        <tbody className="mc-table-body even">

                                            {appointment && appointment.length > 0 ? (
                                                appointment.map((item, index) => (
                                                    <tr key={index}>
                                                        <td title="id">
                                                            <div className="mc-table-check">
                                                                <p>{index + 1}</p>
                                                            </div>
                                                        </td>

                                                        {/* <td title={item.service_name}>
                    <div className="mc-table-profile">
                        <img
                            src={item.service_image ? `${item.service_image}` : `doctor_placeholder.webp`}
                            alt="Profile"
                            style={{ width: '50px', height: '50px', borderRadius: '50%', objectFit: 'cover' }}
                        />
                    </div>
                </td> */}
                                                        <td>{item.clinic_name || 'NA'}</td>
                                                        <td>{item.doctor_name || item.assigned_doctor || 'NA'}</td>
                                                        <td>{item.service_name || 'NA'}</td>
                                                        <td>
                                                            {item.appointment_approved === 0 ? (
                                                                <p className="pending">Pending</p>
                                                            ) : item.appointment_approved === 1 ? (
                                                                <p className="approved">Approved</p>
                                                            ) : (
                                                                <p className="rejected">Rejected</p>
                                                            )}
                                                        </td>
                                                        <td>{item.createtime || 'NA'}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" style={{ textAlign: 'center' }}>No data available</td>
                                                </tr>
                                            )}
                                        </tbody>


                                    </table>

                                </div>
                            </div>
                        )}

                        {content === 1 && (
                            <div style={{ margin: '1rem' }}>
                                <div className="mc-table-responsive">
                                    <table className="mc-table">
                                        <thead className="mc-table-head primary">
                                            <tr>
                                                <th>
                                                    <div className="mc-table-check">
                                                        <p>{t("sno")}</p>
                                                    </div>
                                                </th>


                                                <th>{t("clinic_name")}</th>
                                                <th>{t("service_name")}</th>
                                                <th>{t("consultation_date_time")}</th>
                                            </tr>
                                        </thead>
                                        <tbody className="mc-table-body even">
                                            {consultation && consultation.length > 0 ? (
                                                consultation.map((item, index) => (
                                                    <tr key={index}>
                                                        <td title="id">
                                                            <div className="mc-table-check">
                                                                <p>{index + 1}</p>
                                                            </div>
                                                        </td>
                                                        <td>{item.clinic_name || 'NA'}</td>
                                                        <td>{item.service_name || 'NA'}</td>
                                                        <td>{item.createtime || 'NA'}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="4" style={{ textAlign: 'center' }}>No data available</td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </table >

                                </div>
                            </div>
                        )}
                    </Form>
                </Card.Body>
            </div>
        </PageLayout>
    )
}